<template>
    <div style="width: 100%;height: 100%;">
        <div style="width: 100%;height: 100%;">
            <el-header style="padding-top: 10px;">
                <el-row>
                    <div>
                        <el-input
                            clearable
                            v-model="rForm.czOrbh"
                            size="small"
                            placeholder="请输入测站或编号"
                            style="width: 9vw;margin-right: 20px;"
                        />
                        <span style="font-size: 15px;color: #323232;margin-right: 10px;">时间</span>
                        <el-date-picker
                            v-model="rsvrDataRange"
                            :clearable=false
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm"
                            popper-class='myDatePicker'
                            type="datetimerange"
                            range-separator="到"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                        >
                        </el-date-picker>
                        <!-- <el-date-picker
                            v-model="rsvrDataRange[0]"
                            :clearable=false
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            popper-class='myDatePicker'
                            type="datetime"
                            start-placeholder="开始日期"
                            size="small"
                        >
                        </el-date-picker>
                        <span style="font-size: 15px;color: #323232;margin: 0 10px;">至</span>
                        <el-date-picker
                            v-model="rsvrDataRange[1]"
                            :clearable=false
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            popper-class='myDatePicker'
                            type="datetime"
                            start-placeholder="开始日期"
                            size="small"
                        >
                        </el-date-picker> -->
                        <el-button type="primary" size="small" class="czBut queryButton" @click="reset">重置</el-button>
                        <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="searchData">搜索</el-button>
                        <el-button type="primary" size="small" class="queryButton queryButtonPadding qDcBtn" @click="exportYq">
                            <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
                            &nbsp;导出
                        </el-button>
                    </div>
                </el-row>
            </el-header>
            <el-row style="overflow: hidden;margin: 0 20px;height: calc(100% - 70px);width: 100%;box-sizing: border-box;">
                <el-col :span="12" style="background-color: #fff;position: relative;height: 100%;">
                    <div style="height: 100%;">
                        <el-table ref="multipleTable" :data="tableData" height="calc(100% - 60px)" border :header-cell-style="{background:'#f9f9ff',color:'#323232','text-align':'center'}" highlight-current-row @row-click="clickData">
                            <el-table-column prop="stcd" fixed label="测站编号" align="center" width="140">
                                <template slot-scope="scope">
                                    <span style="cursor: pointer;color: #46adf5" @click.stop="clickJcz(scope.row)">{{ scope.row.stcd }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="stnm" fixed label="测站名称" align="left" width="180">
                                <template slot-scope="scope">
                                    <el-tooltip class="item" effect="dark" :content="scope.row.stnm" placement="top" width="200">
                                        <span v-if="scope.row.stnm.length <= 8">
                                            {{scope.row.stnm}}
                                        </span>
                                        <span v-if="scope.row.stnm.length > 8">
                                            {{scope.row.stnm.substr(0, 8) + "..."}}
                                        </span>
                                    </el-tooltip>
                                    <img v-show="scope.row.mstp.indexOf('0607')>=0" src="../../assets/images/ysqjc/wjx.png" style="vertical-align: text-top;">
                                </template>
                            </el-table-column>
                            <el-table-column prop="tm" label="时间" align="center" width="180">
                                <template slot-scope="scope">
                                    <span style="">
                                        {{ scope.row.tm ? scope.row.tm : '-' }}
                                    </span>
                                </template>
                            </el-table-column> 
                            <el-table-column prop="rz" label="库水位(m)" align="right" width="130">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.rz ? scope.row.rz : '-' }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="w" label="蓄水量(10⁴m³)" align="right" width="130">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.w ? scope.row.w : '-' }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="inboundFlow" label="入库流量(m³/s)" align="right" width="140">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.inboundFlow ? scope.row.inboundFlow : '-' }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="outboundFlow" label="出库流量(m³/s)" align="right" width="140">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.outboundFlow ? scope.row.outboundFlow : '-' }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sttpCode" label="测站类型" align="center" width="120"/>
                        </el-table>
                        <page-footer
                            :rForm="rForm"
                            @size-change="sizeChange"
                            @current-change="currentChange"
                            style="position: absolute;bottom: 10px;right: 10px;"
                        >
                        </page-footer>
                    </div>
                </el-col>
                <el-col :span="12" style="height: 100%;">
                    <div style="margin-left: 20px;position: relative;height: 100%;width: 100%;">
                        <div style="position: absolute;top: 10px;left: 20px;z-index: 10;">
                            <el-tooltip content="回到中心点" placement="bottom" effect="light">
                                <img src="@/assets/images/ysqjc/sxwz.png" style="cursor: pointer;" @click="sxwz">
                            </el-tooltip>
                        </div>
                        <div style="position: absolute;bottom: 0px;left: 0;z-index: 10;">
                            <div style="width: 200px;height: 70px;background-color: #fff;">
                                <div style="text-align: center;font-size: 14px;line-height: 30px;">
                                    图例
                                </div>
                                <div style="display: flex;line-height: 30px;font-size: 12px;">
                                    <div style="margin-left: 10px;margin-right: 10px;">
                                        <img src="@/assets/images/ysqjc/skC.png" style="vertical-align: middle;margin-right: 5px;">
                                        <span>超设计</span>
                                    </div>
                                    <div style="margin-right: 10px;">
                                        <img src="@/assets/images/ysqjc/skB.png" style="vertical-align: middle;margin-right: 5px;">
                                        <span>超汛限</span>
                                    </div>
                                    <div style="margin-right: 10px;">
                                        <img src="@/assets/images/ysqjc/skA.png" style="vertical-align: middle;margin-right: 5px;">
                                        <span>正常</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 地图弹出框 -->
                        <div v-show="isShow && tckData" id="popupA">
                            <div class="ol-popup" id="popup-contentA">
                                <div>
                                    <div style="position: absolute;transform: translate(0%,-50%);top: 50%;left: 10px;font-size: 1.4rem;">
                                        {{ tckData ? (tckData.stnm ? tckData.stnm : '') : '' }}
                                    </div>
                                    <div style="position: absolute;transform: translate(0%,-50%);top: 50%;right: 10px;font-size: 1.4rem;">
                                        {{ tckData ? (tckData.stcd ? tckData.stcd : '') : '' }}
                                    </div>
                                </div>
                            </div>
                            <div style="position: absolute;min-width: 260px;left: 20px;top: -20px;background-color: #fff;font-family: 'PingFang SC';font-size: 1.4rem;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;">
                                <div style="width: 260px;">
                                    <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                                        <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                            库水位(m)
                                        </span>
                                        <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                            {{tckData.rz ? tckData.rz : '-'}}
                                        </span>
                                    </div>
                                    <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                                        <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                            蓄水量(10⁴m³)
                                        </span>
                                        <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                            {{tckData.w ? tckData.w : '-'}}
                                        </span>
                                    </div>
                                    <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                                        <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                            入库流量(m³/s)
                                        </span>
                                        <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                            {{tckData.inboundFlow ? tckData.inboundFlow : '-'}}
                                        </span>
                                    </div>
                                    <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                                        <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                            出库流量(m³/s)
                                        </span>
                                        <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                            {{tckData.outboundFlow ? tckData.outboundFlow : '-'}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 地图 -->
                        <div class="map" id="olMap"></div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <rsvrOpen :rsvrCz="rsvrCz" ref="rsvrChildren"></rsvrOpen>
    </div>
</template>

<script>
import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import { Tile as TileLayer, Vector as VectorLayer, Image } from "ol/layer";
import VectorSource from "ol/source/Vector";
import { XYZ, WMTS, ImageWMS } from "ol/source";
import { defaults as defaultControls } from "ol/control";
import Point from "ol/geom/Point";
import Feature from "ol/Feature";
import Overlay from "ol/Overlay";
import { Icon,Style,Stroke,Fill,CircleStyle,Circle,Text } from "ol/style";

import ImageLayer from 'ol/layer/Image';
import { GeoJSON, WKT } from "ol/format";
import LinearRing from 'ol/geom/LinearRing.js';
import { fromExtent } from "ol/geom/Polygon";

import pageFooter from "@/components/pageFooter";
import rsvrOpen from "@/views/rainWaterS/open/rsvrOpen.vue";

let tdtLayer = null;
let yxdtLayer = null;
let hlLayer =null;
let dtImage = new VectorLayer({
    source: new VectorSource(),
    visible: true,
});
let cz_img = new VectorLayer({
    source:new VectorSource(),
    visible: true,
    zIndex:110,
});

export default {
    name: "rsvr",
    components: {
        pageFooter,rsvrOpen
    },
    data(){
        return{
            skdtxx:[],
            tableData:[],
            zgData:[],
            // 查询表单
            rsvrDataRange: [],
            rForm: {
                size: 10,
                current: 1,
                total: 0,
                czOrbh:"",
            },
            rsvrCz:{
                openShow:false,
                cz:{},
                sjfw:[],
            },
            geoImageWMSConfig:{
                params: {LAYERS: '', VERSION: '1.1.0', SRS: 'EPSG:4326'},
                serverType: 'geoserver',
                url: '//gis.hyicloud.com/zxsk/wms',
            },
            map:null,
            maplx:null,
            zoomNum:10,
            center:[83.166136, 42.148747],
            mapData:[],
            initLayer:null,
            xzData:{},
            isShow: false,
            tckData:{},
        }
    },
    watch:{
        "$store.state.head.skCd"() {
           //调用页面查询方法
            this.pageList();
            this.qhMap();
        },
    },
    mounted() {
        this.hqskdtxx();
        this.initDataItem();
    },
    methods: {
        xgDate(dateStr){
            dateStr = dateStr.substring(0,19);
            dateStr = dateStr.replace(/-/g,'/');
            var timeTamp = new Date(dateStr).getTime();
            return timeTamp;
        },
        // 分页查询
        pageList() {
            let qwer1 = this.xgDate(this.rsvrDataRange[0].substr(0,13) + ':00:00');
            let qwer2 = this.xgDate(this.rsvrDataRange[1].substr(0,13) + ':00:00');
            qwer1 = qwer1/(60*60*1000);
            qwer2 = qwer2/(60*60*1000);
            let qwer = qwer2 - qwer1;
            if (qwer > 8784) {
                this.$message.warning('查询时间不允许超过一年！');
                return;
            }


            let a = {
                ...this.rForm,
                tmGT:this.rsvrDataRange[0] + ':00',
                tmLE:this.rsvrDataRange[1] + ':00',
            }
            this.request.get("/rm-mrsvr/v1/pageList",{params:a}).then((res) => {
                if(res.ok){
                    this.tableData = res.data.records;
                    this.rForm.total = res.data.total;

                    if (this.rForm.czOrbh != '') {
                        this.mapData = this.tableData;
                        this.mapTb();
                        return;
                    } else {
                        let htGE = this.rsvrDataRange[0] + ':00';
                        let htLE = this.rsvrDataRange[1] + ':00';
                        let b = {
                            tmGT:htGE,
                            tmLE:htLE,
                        }
                        this.request.get('/rm-mrsvr/v1/list',{ params: b }).then((res) => {
                            if(res.ok){
                                this.mapData = res.data;
                                this.mapTb();
                                this.showCzData();
                            }else{
                                this.$message.error(res.error.message)
                            }
                        });
                    }
                    


                }else{
                    this.$message.error(res.error.message)
                }
            });

            
        },
        // 查询数据
        searchData() {
            this.rForm.current = 1;
            this.pageList();
        },
        // 切换分页
        currentChange(val) {
            this.rForm.current = val;
            this.pageList();
        },
        // 显示最大条数变动
        sizeChange(val) {
            this.rForm.size = val;
            this.searchData();
        },

        reset() {
            this.rForm.czOrbh = '';
            this.initDataItem();
            this.sxwz();
        },
        initDataItem(){
            var today = new Date();
            var jr = ''
            var zr = ''
            if(today.getHours() < 8){
                jr = this.getDay(-1).substring(0,this.getDay(0).length-5)
                zr = this.getDay(-2).substring(0,this.getDay(0).length-5)
            }else{
                jr = this.getDay(0).substring(0,this.getDay(0).length-5)
                zr = this.getDay(-1).substring(0,this.getDay(0).length-5)
            }
            this.rsvrDataRange = []
            this.rsvrDataRange.push(jr+"08:00")
            this.rsvrDataRange.push(this.getDay(0))
            this.searchData();
        },
        getDay(day) {
            var today = new Date();
            var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码

            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            var thours = today.getHours();
            thours = this.doHandleMonth(thours);
            var tMinute =  today.getMinutes();
            tMinute = this.doHandleMonth(tMinute);
            return tYear + "-" + tMonth + "-" + tDate +" "+thours+":"+tMinute;
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = "0" + month;
            }
            return m;
        },

        clickData(row, event, column){
            let zoomz = this.fdlevel;
            if (row.lgtd&&row.lttd) {
                this.map.getView().animate({
                    center: [row.lgtd,row.lttd],
                    zoom: zoomz,
                });
            } else {
                return;
            }
        },
        clickJcz(val){
            this.rsvrCz.openShow = true;
            this.rsvrCz.cz = val;
            this.rsvrCz.sjfw = [...this.rsvrDataRange];
            // this.$refs.rsvrChildren.jygcData();
        },
        exportYq(){
            let htGE = this.rsvrDataRange[0] + ':00';
            let htLE = this.rsvrDataRange[1] + ':00';
            let b = {
                tmGT:htGE,
                tmLE:htLE,
            }
            this.request.get('/rm-mrsvr/v1/export',{ params: b,responseType: "blob" }).then((res) => {
                try {
                    let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const a = document.createElement("a");
                    a.href = URL.createObjectURL(blob);
                    // 这里填保存成的文件名
                    a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
                    a.click();
                    URL.revokeObjectURL(a.href);
                    return;
                } catch (error) {
                    const reader = new FileReader(); 
                    reader.readAsText(res.data, 'utf-8');
                    let _this = this;
                    reader.onload=function(){
                        const msg = JSON.parse(reader.result);
                        if (!msg.ok) {
                            if (msg.error.code == 3001) {
                                _this.$message.error(msg.error.message);
                            } else {
                                _this.$message.warning(msg.error.message);
                            }
                        }
                    }
                }
            });
        },

        qhMap(){
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            if (skCd) {
                if(skCd == '65292330001'){
                    this.showArea();
                    tdtLayer.setVisible(true);
                    hlLayer.setVisible(true);
                    yxdtLayer.setVisible(false);
                } else {
                    yxdtLayer.setVisible(true);
                    tdtLayer.setVisible(false);
                    hlLayer.setVisible(false);
                    this.map.removeLayer(this.initLayer);
                }

                for (let i = 0; i < this.skdtxx.length; i++) {
                    if (skCd == parseFloat(this.skdtxx[i].bh)) {
                        this.zoomNum = parseFloat(this.skdtxx[i].level);
                        this.fdlevel = parseFloat(this.skdtxx[i].fdlevel);
                        this.center[0] = parseFloat(this.skdtxx[i].jd);
                        this.center[1] = parseFloat(this.skdtxx[i].wd);
                        break;
                    } else {
                        this.zoomNum = 4;
                        this.center = [103.95, 34.10];
                    }
                }
                let view = this.map.getView();
                view.setZoom(this.zoomNum); // 重新设置地图放大倍数
                view.setCenter(this.center,'EPSG:4326'); // 重新设置中心点的坐标
            } else {
                return;
            }
        },
        //初始化地图
        initMap() {
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            for (let i = 0; i < this.skdtxx.length; i++) {
                if (skCd == parseFloat(this.skdtxx[i].bh)) {
                    this.maplx = this.skdtxx[i].map;
                    this.zoomNum = parseFloat(this.skdtxx[i].level);
                    this.fdlevel = parseFloat(this.skdtxx[i].fdlevel);
                    this.center[0] = parseFloat(this.skdtxx[i].jd);
                    this.center[1] = parseFloat(this.skdtxx[i].wd);
                    break;
                } else {
                    this.zoomNum = 4;
                    this.center = [103.95, 34.10];
                }
            }

            tdtLayer = new TileLayer({
                source: new XYZ({  //矢量底图
                    url: 'https://t{0-7}.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=vec_w&tk=8156b60f5ff7ee9619e3c84a1a7fe491'
                }),
                visible: true,
            });
            yxdtLayer = new TileLayer({
                source: new XYZ({  //影像底图
                    url: 'https://t{0-7}.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=img_w&tk=8156b60f5ff7ee9619e3c84a1a7fe491'
                }),
                visible: false,
            });

            if (skCd) {
                if(skCd == '65292330001' || this.maplx == "JD"){
                    tdtLayer.setVisible(true);
                    yxdtLayer.setVisible(false);
                } else if(this.maplx == "YX") {
                    tdtLayer.setVisible(false);
                    yxdtLayer.setVisible(true);
                }
            }
            // 加载地图
            const map = new Map({
                target: "olMap",
                layers:[tdtLayer,yxdtLayer],
                view: new View({
                    //中心点经纬度
                    center: this.center,
                    //图层缩放大小
                    zoom: this.zoomNum,
                    projection: "EPSG:4326",
                    minZoom: 4,
			        maxZoom: 18,
                }),
                controls: defaultControls({
                    zoom: true,
                    attribution: false,
                    rotate: false,
                }),
            });
            this.map = map;

            //创建蒙层，凸显区域
            this.showArea();

            

            // 添加注记
            // let cvaUrl = "http://t{0-7}.tianditu.com/DataServer?x={x}&y={y}&l={z}&T=cva_c&tk=8156b60f5ff7ee9619e3c84a1a7fe491";
            // const sourceCVA = new XYZ({
            //     url: cvaUrl,
            //     projection: "EPSG:4326",
            // });
            // const tdtcvaLayer = new TileLayer({
            //     title: '世界名称底图',
            //     source: sourceCVA,
            // });
            // this.map.addLayer(tdtcvaLayer);
        },
        showArea(d,val){
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            if (skCd) {
                if (skCd == '65292330001') {
                    if (d) {
                        this.map.removeLayer(this.initLayer);
                    }
                    let mcYs = 'rgba( 0, 0, 0, 0.1)';
                    
                    this.initLayer = new VectorLayer({
                        zIndex: 3,
                        source: new VectorSource(),
                        style: new Style({
                            fill: new Fill({
                                color:mcYs,
                            }),
                            stroke: new Stroke({
                                color:"#f4b49f",
                                // color:'rgba(255, 255, 255, 1)',
                                width:2,
                            }),
                        })
                    });
                    this.map.addLayer(this.initLayer);
                    let url = "https://gis.hyicloud.com/zxsk/ows?service=WFS&version=1.1.0&request=GetFeature&outputFormat=json&typeName=zxsk:tcsk";
                    // let url = "https://gis.hyicloud.com/area_border/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=json&typeName=area_border:districtBorder&cql_filter=id=150627";
                    this.$axios.get(url).then((res) => {
                        this.addConver(this.initLayer, res.data.features[0]);
                    });
                }
            } else {
                return;
            }
        },
        //添加遮罩
        addConver(converLayer, data) {
            const fts = new GeoJSON().readFeatures(data);
            const ft = fts[0];
            const converGeom = this.erase(ft.getGeometry());
            const convertFt = new Feature({
                geometry: converGeom,
            });
            converLayer.getSource().addFeature(convertFt);
        },
        //擦除操作，生产遮罩范围
        erase(geom) {
            const extent = [-180, -90, 180, 90];
            const polygonRing = fromExtent(extent);
            const coords = geom.getCoordinates();
            coords.forEach(coord => {
                const linearRing = new LinearRing(coord[0]);
                polygonRing.appendLinearRing(linearRing);
            });
            return polygonRing;
        },
        // 河流图层
        sethlLayer(){
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            if (skCd) {
                if (skCd == '65292330001') {
                    let iwconfigs = {...this.geoImageWMSConfig};
                    iwconfigs.params.LAYERS = "zxsk:rivers";
                    let source = new ImageWMS({...iwconfigs});
                    hlLayer = new ImageLayer({
                        title: '河流图层',
                        source: source,
                        zIndex:120,
                        visible: true,
                    });
                    this.map.addLayer(hlLayer);
                } else {
                    let iwconfigs = {...this.geoImageWMSConfig};
                    iwconfigs.params.LAYERS = "zxsk:rivers";
                    let source = new ImageWMS({...iwconfigs});
                    hlLayer = new ImageLayer({
                        title: '河流图层',
                        source: source,
                        zIndex:120,
                        visible: false,
                    });
                    this.map.addLayer(hlLayer);
                }
            } else {
                return;
            }
        },
        //地图添加图标
        mapTb(){
            this.map.removeLayer(dtImage);
            dtImage = new VectorLayer({
                source: new VectorSource(),
                visible: true,
                zIndex: 120,
            });
            this.map.addLayer(dtImage);

            this.mapData.forEach((n) => {
                const ext = [parseFloat(n.lgtd), parseFloat(n.lttd)];
                const wzimage = new Feature(new Point(ext));
                if (n.rz) {
                    if (n.sjhsw && n.rz>n.sjhsw) {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/skC.png"),scale: 1,zIndex: 110,})}));
                    } else if(n.fhxzsw && n.rz>n.fhxzsw) {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/skB.png"),scale: 1,zIndex: 110,})}));
                    } else {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/skA.png"),scale: 1,zIndex: 110,})}));
                    }
                } else {
                    wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/skA.png"),scale: 1,zIndex: 110,})}));
                }
                
                wzimage.set("stcd", n.stcd);
                wzimage.set("data", n);
                dtImage.getSource().addFeature(wzimage);
            });
            this.showCzData();
        },
        //鼠标点击事件
        addMapClick(){
            const _this = this;
            this.map.on("singleclick", function (e) {
                const pixelT = e.pixel;
                const feature = _this.map.forEachFeatureAtPixel(
                    pixelT,
                    function (fea) {
                        return fea;
                    }
                );
                //找到了要素
                if (feature) {
                    const container = document.getElementById("popupA");
                    const overlayA = new Overlay({
                        element: container,
                    });
                    _this.map.addOverlay(overlayA);
                    const cz = {
                        stcd:'',
                    }
                    cz.stcd = feature.get("stcd");
                    if (cz) {
                        if (cz.stcd) {
                            _this.clickJcz(cz);
                        }
                    }
                }else{
                    return;
                }
            });
        },
        addPointermove(){
            const _this = this;
            this.map.on('pointermove',function(e) {
                var pixel=_this.map.getEventPixel(e.originalEvent);
                var feature=_this.map.forEachFeatureAtPixel(
                    pixel,
                    function (feature) {
                        return feature;
                    }
                )
                if (feature) {
                    let stcd = feature.get("stcd");
                    if (stcd) {
                        _this.tckData = feature.get("data");
                        const container = document.getElementById("popupA");
                        const overlayA = new Overlay({
                            element: container,
                        });
                        _this.map.addOverlay(overlayA);
                        let coodinate = [_this.tckData.lgtd,_this.tckData.lttd];
                        overlayA.setPosition(coodinate);

                        _this.map.getTargetElement().style.cursor="pointer";
                        _this.isShow = true;
                    } else {
                        _this.map.getTargetElement().style.cursor="auto";
                        _this.isShow = false;
                    }
                } else {
                    _this.map.getTargetElement().style.cursor="auto";
                    _this.isShow = false;
                }
            })
        },
        //鼠标滚动事件
        addMapWheel() {
            this.gd = () => {
                this.showCzData();
            }
            this.map.addEventListener('moveend', this.gd, true);
        },
        showCzData(){
            let curLevel = this.map.getView().getZoom();
            if(curLevel >= 10.5){
                this.czname();
            } else {
                if (cz_img) {
                    cz_img.getSource().getFeatures().forEach(function(feature) {
                        if (!feature.style_) {
                            return;
                        }
                        if (feature.style_.text_) {
                            cz_img.getSource().removeFeature(feature);
                        }
                    });
                } else {
                    return;
                }
            }
        },
        czname(){
            this.map.removeLayer(cz_img);
            cz_img = new VectorLayer({
                source: new VectorSource(),
                visible: true,
                zIndex: 120,
            });
            this.map.addLayer(cz_img);
            for(let data of this.tableData){
                const ext = [parseFloat(data.lgtd), parseFloat(data.lttd)];
                const wzimage = new Feature(new Point(ext));
                wzimage.setStyle(
                    new Style(
                        {
                            text:new Text(
                                {
                                    text: '\r\r'+data.stnm+'\r',
                                    textAlign: "center",
                                    offsetY: 20,
                                    backgroundFill: new Stroke({
                                        color: 'rgba(44, 131, 234,1)',
                                    }),
                                    // 文本填充样式
                                    fill: new Fill({
                                        color: 'rgba(255,255,255,1)',
                                    }),
                                    scale: 1.5
                                }
                            )
                        }
                    )
                )
                wzimage.set("data", data);
                cz_img.getSource().addFeature(wzimage);
            }
        },
        sxwz(){
            this.$refs.multipleTable.setCurrentRow();
            if (this.map) {
                let view = this.map.getView();
                view.setZoom(this.zoomNum); // 重新设置地图放大倍数
                view.setCenter(this.center,'EPSG:4326'); // 重新设置中心点的坐标
            }
        },
        hqskdtxx(){
            this.request.get('/rm-bspecial/v1/list').then((res) => {
                if(res.ok){
                    this.skdtxx = res.data;
                    let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
                    for (let i = 0; i < this.skdtxx.length; i++) {
                        if (skCd == parseFloat(this.skdtxx[i].bh)) {
                            this.zoomNum = parseFloat(this.skdtxx[i].level);
                            this.fdlevel = parseFloat(this.skdtxx[i].fdlevel);
                            this.center[0] = parseFloat(this.skdtxx[i].jd);
                            this.center[1] = parseFloat(this.skdtxx[i].wd);
                            break;
                        } else {
                            this.zoomNum = 4;
                            this.center = [103.95, 34.10];
                        }
                    }
                    this.initMap();
                    this.addMapClick();//鼠标点击事件
                    this.addPointermove();//鼠标移入事件
                    this.addMapWheel();//鼠标滚动事件
                    this.sethlLayer();//初始化河流图层
                }else{
                    this.$message.error(res.error.message)
                }
            });
        },
    },
}
</script>

<style scoped>
/* 一般浏览器的不要太小，容易看不见 */
::-webkit-scrollbar {
    width: 8px;
}
::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: rgba(0,0,0,0.2);
}
::-webkit-scrollbar-track {
    border-radius: 0;
    background: rgba(0,0,0,0.1);
}
/* 去掉table 最底部的线 */
div /deep/ .el-table--border::after,
div /deep/ .el-table--group::after,
div /deep/ .el-table::before {
    background-color: transparent;
}
::v-deep .el-table__body tr.current-row > td {
    background-color: #F0F0FC;
}
.queryButton {
    font-family: PingFang SC;
    font-size: 1.4rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    border-radius: 0.5rem;
    margin-left: 1.5rem;
}
.czBut {
    background-color: #a8a8a8;
    border: solid 0rem #f4f4f4;
}
.queryButtonPadding {
    padding-left: 2rem;
    padding-right: 2rem;
}
.qDcImg {
    width: 1.2rem;
    height: 1.2rem;
}
.qDcBtn {
    position: absolute;
    right: 4rem;
}
.stnmyyy{
    color: #5794F8;
}

.map {
    width: 100%;
    height: calc(100vh - 110px);
}
::v-deep .ol-zoom{
    display:none;
}
/* 地图弹框样式 */
.ol-popup {
    position: absolute;
    bottom: 20px;
    left: 20px;
    min-width: 256px;
    height: 40px;
    background-color: #2c83ea;
    font-family: "PingFang SC";
    color: #FFFFFF;
    border: 2px solid #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
</style>